import { render, staticRenderFns } from "./BaseTabsBox.vue?vue&type=template&id=0c4d59be&scoped=true"
import script from "./BaseTabsBox.vue?vue&type=script&lang=js"
export * from "./BaseTabsBox.vue?vue&type=script&lang=js"
import style0 from "./BaseTabsBox.vue?vue&type=style&index=0&id=0c4d59be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4d59be",
  null
  
)

export default component.exports